import styled from 'styled-components';

const Img = styled.img`
  display: block;
  object-fit: contain;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
`;

const FacilityIcon = ({ facility, size = 20 }) => {
  if (Boolean(facility?.iconUrl)) {
    return (
      <Img size={size} src={facility?.iconUrl} alt={facility?.displayName} />
    );
  }

  return <i className="fa-regular fa-building" style={{ fontSize: size }} />;
};

export default FacilityIcon;
